module.exports = __webpack_public_path__ + "static/media/workair.96cf0e37.png";